/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit ConfirmAction/view.blocks to change it.
import * as fromHelpers from './helpers.js'
import React from 'react'
import TysiaButton from 'DesignSystem/TysiaButton/index'
import TysiaButtonText from 'DesignSystem/TysiaButton/TysiaButtonText/index'



/** @type {import('Simple/types.js').View} */
export default function ConfirmAction({
  children,
  viewPath = "/DesignSystem/TysiaInputDateRange/TysiaDateRange/Actions/ConfirmAction",
  disabled,
  closePopover,
  onSave
  
}) {
let onClick = fromHelpers.useOnConfirmClick({
  children,
  viewPath,
  disabled,
  closePopover,
  onSave
  
})
  return (<React.Fragment
>
<TysiaButton
  viewPath={`${viewPath}/TysiaButton`}
 type="primary"
 disabled={disabled}
 closePopover={closePopover}
 onSave={onSave}
 onClick={onClick}
>
{childProps => (
<TysiaButtonText
{...childProps}
  viewPath={`${viewPath}/TysiaButtonText`}
 text="Confirm"
/>
)}
</TysiaButton>
{children}
</React.Fragment>)
}